<ag-grid-angular
  #contractSelectionGrid
  class="ag-theme-material rule-list-grid-height rule-list-ag-grid"
  [style.height]="gridHeight"
  [rowData]="contracts"
  [suppressMenuHide]="true"
  (filterChanged)="onFilterChanged($event)"
  [valueCache]="true"
  [columnDefs]="columnDefs"
  [cacheQuickFilter]="true"
  [defaultColDef]="defaultColDef"
  [gridOptions]="gridOptions"
  [statusBar]="statusBar"
  [animateRows]="true"
  [overlayNoRowsTemplate]="overLayNoRows"
  [suppressContextMenu]="true"
  (columnVisible)="onColumnChanged($event)"
  (columnMoved)="onColumnChanged($event)"
  (columnPinned)="onColumnChanged($event)"
  (columnResized)="onColumnChanged($event)"
  (gridReady)="onGridReady($event)"
  [sideBar]="sideBar"
  rowSelection="single"
  [rowMultiSelectWithClick]="true"
  (rowSelected)="contractSelected($event)"
>
</ag-grid-angular>
@if (contracts?.length === 0) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
